import type { Messages } from '@lingui/core'
import { i18n } from '@lingui/core'

const DEFAULT_LOCALE = 'en'

const loadEnglishCatalog = async (): Promise<Messages> => {
    // Reuse the generated dashboard catalog until lune-dashboard owns its own Lingui extraction.
    const { messages } = await import('../../dashboard/src/locales/en/messages.mjs')
    return messages
}

export const initI18n = async (): Promise<void> => {
    try {
        const messages = await loadEnglishCatalog()
        i18n.load(DEFAULT_LOCALE, messages)
    } catch (error) {
        console.warn('Failed to load the dashboard English catalog for lune-dashboard', error)
        i18n.load(DEFAULT_LOCALE, {})
    }

    i18n.activate(DEFAULT_LOCALE)
}

export { i18n }
